import * as Yup from 'yup'
import { Formik, Field } from 'formik'
import { Close } from '@mui/icons-material'

import {
  Divider,
  Grid,
  Dialog,
  TextField,
  Container,
  CardContent,
  MenuItem,
  DialogTitle,
  IconButton,
  Card,
  FormControlLabel,
  Switch
} from '@mui/material'
import { ActionButton } from '../../../utils/ui_utils'

function BusinessDialog({
  visible,
  title,
  okText,
  onSubmit,
  onClose,
  initialValues,
  applicationData,
  mode = 'create'
}) {
  if (initialValues == undefined) {
    initialValues = {
      name: '',
      gstn: '',
      telephone: '',
      fax: '',
      cin: '',
      address: '',
      city: '',
      pin: '',
      state: '',
      country: '',
      multi_outlet: false,
      application_id: '',
      dealer_code: ''
    }
  }

  if (applicationData == undefined) applicationData = []

  let validationSchema = {}
  if (mode === 'create') {
    validationSchema = Yup.object().shape({
      name: Yup.string()
        .required('Required')
        .min(2, 'Min length is 2 character'),
      // gstn: Yup.string().required('Required').min(15, 'Min length is 15'),
      telephone: Yup.string().min(10, 'Min 10 digits').required('Required'),
      city: Yup.string().required('Required'),
      address: Yup.string().required('Required'),
      pin: Yup.string().required('Required'),
      state: Yup.string().required('Required'),
      country: Yup.string().required('Required'),
      application_id: Yup.string().required('Required'),
      dealer_code: Yup.string()
        .required('Required')
        .min(10, 'Min length is 10 character')
    })
  } else {
    validationSchema = Yup.object().shape({
      name: Yup.string()
        .required('Required')
        .min(2, 'Min length is 2 character'),
      // gstn: Yup.string().required('Required').min(15, 'Min length is 15'),
      telephone: Yup.string().min(10, 'Min 10 digits').required('Required'),
      city: Yup.string().required('Required'),
      address: Yup.string().required('Required'),
      pin: Yup.string().required('Required'),
      state: Yup.string().required('Required'),
      country: Yup.string().required('Required')

      // application_id: Yup.string().required('Required'),
    })
  }
  const handleSubmit = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting }
  ) => {
    //values.multi_outlet = toggle
    //ss
    onSubmit(values)
  }

  return (
    <>
      <Dialog open={visible} aria-labelledby="form-dialog-title">
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          {title}
          <IconButton
            component="span"
            size="small"
            sx={{ ':hover': { backgroundColor: 'red', color: 'white' } }}
            onClick={onClose}
            variant="contained"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <Container sx={{ marginBottom: 5 }}>
          <Divider my={1} />
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values,
              status,
              setFieldValue
            }) => (
              <form onSubmit={handleSubmit}>
                <Card>
                  <CardContent>
                    <Grid container direction={'column'} spacing={2}>
                      <Grid item>
                        <Grid container spacing={6}>
                          <Grid item md={6}>
                            <TextField
                              size="small"
                              name="name"
                              label="Name"
                              value={values.name}
                              error={Boolean(touched.name && errors.name)}
                              fullWidth
                              helperText={touched.name && errors.name}
                              onBlur={handleBlur}
                              margin="dense"
                              onChange={handleChange}
                              variant="outlined"
                              my={2}
                            />
                          </Grid>
                          <Grid item md={6}>
                            <TextField
                              size="small"
                              name="telephone"
                              label="Telephone"
                              value={values.telephone}
                              error={Boolean(
                                touched.telephone && errors.telephone
                              )}
                              fullWidth
                              helperText={touched.telephone && errors.telephone}
                              onBlur={handleBlur}
                              margin="dense"
                              onChange={handleChange}
                              variant="outlined"
                              my={2}
                            />
                          </Grid>
                        </Grid>

                        <Grid container spacing={6}>
                          <Grid item md={6}>
                            <TextField
                              size="small"
                              name="gstn"
                              label="GSTN"
                              value={values.gstn}
                              error={Boolean(touched.gstn && errors.gstn)}
                              fullWidth
                              helperText={touched.gstn && errors.gstn}
                              onBlur={handleBlur}
                              margin="dense"
                              onChange={handleChange}
                              variant="outlined"
                              my={2}
                            />
                          </Grid>
                          <Grid item md={6}>
                            <TextField
                              size="small"
                              name="fax"
                              label="Fax"
                              value={values.fax}
                              error={Boolean(touched.fax && errors.fax)}
                              fullWidth
                              helperText={touched.fax && errors.fax}
                              onBlur={handleBlur}
                              margin="dense"
                              onChange={handleChange}
                              variant="outlined"
                              my={2}
                            />
                          </Grid>
                        </Grid>

                        <Grid container spacing={6}>
                          <Grid item md={6}>
                            <TextField
                              size="small"
                              name="cin"
                              label="CIN"
                              value={values.cin}
                              error={Boolean(touched.cin && errors.cin)}
                              fullWidth
                              helperText={touched.cin && errors.cin}
                              onBlur={handleBlur}
                              margin="dense"
                              onChange={handleChange}
                              variant="outlined"
                              my={2}
                            />
                          </Grid>
                          <Grid item md={6}>
                            <TextField
                              size="small"
                              name="pin"
                              label="Pin"
                              value={values.pin}
                              error={Boolean(touched.pin && errors.pin)}
                              fullWidth
                              helperText={touched.pin && errors.pin}
                              onBlur={handleBlur}
                              margin="dense"
                              onChange={handleChange}
                              variant="outlined"
                              my={2}
                            />
                          </Grid>
                        </Grid>

                        <Grid container spacing={6}>
                          <Grid item md={4}>
                            <TextField
                              size="small"
                              name="city"
                              label="City"
                              value={values.city}
                              error={Boolean(touched.city && errors.city)}
                              fullWidth
                              helperText={touched.city && errors.city}
                              onBlur={handleBlur}
                              margin="dense"
                              onChange={handleChange}
                              variant="outlined"
                              my={2}
                            />
                          </Grid>
                          <Grid item md={4}>
                            <TextField
                              size="small"
                              name="state"
                              label="State"
                              value={values.state}
                              error={Boolean(touched.state && errors.state)}
                              fullWidth
                              helperText={touched.state && errors.state}
                              onBlur={handleBlur}
                              margin="dense"
                              onChange={handleChange}
                              variant="outlined"
                              my={2}
                            />
                          </Grid>
                          <Grid item md={4}>
                            <TextField
                              size="small"
                              name="country"
                              label="Country"
                              value={values.country}
                              error={Boolean(touched.country && errors.country)}
                              fullWidth
                              helperText={touched.country && errors.country}
                              onBlur={handleBlur}
                              margin="dense"
                              onChange={handleChange}
                              variant="outlined"
                              my={2}
                            />
                          </Grid>
                        </Grid>

                        <Grid container spacing={6}>
                          <Grid item md={12}>
                            <TextField
                              name="address"
                              label="Address"
                              value={values.address}
                              error={Boolean(touched.address && errors.address)}
                              fullWidth
                              helperText={touched.address && errors.address}
                              onBlur={handleBlur}
                              margin="dense"
                              onChange={handleChange}
                              variant="outlined"
                              multiline
                              my={2}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={6}>
                          <Grid item md={12}>
                            <TextField
                              size="small"
                              name="dealer_code"
                              label="Dealer Code"
                              value={values.dealer_code}
                              error={Boolean(
                                touched.dealer_code && errors.dealer_code
                              )}
                              disabled={mode !== 'create'}
                              fullWidth
                              helperText={
                                touched.dealer_code && errors.dealer_code
                              }
                              onBlur={handleBlur}
                              margin="dense"
                              onChange={handleChange}
                              variant="outlined"
                              my={2}
                            />
                          </Grid>
                        </Grid>
                        <FormControlLabel
                          control={
                            <Field
                              label="Multi Outlet"
                              name="multi_outlet"
                              component={Switch}
                              onChange={(event, checked) => {
                                setFieldValue('multi_outlet', !!checked)
                              }}
                              checked={values.multi_outlet}
                            />
                          }
                          label="Multi Outlet"
                        />
                      </Grid>
                      {mode === 'create' && (
                        <Grid item>
                          <TextField
                            size="small"
                            id="application_id"
                            label="Application"
                            name="application_id"
                            // required={true}
                            value={values.application_id}
                            error={Boolean(
                              touched.application_id && errors.application_id
                            )}
                            fullWidth
                            onBlur={handleBlur}
                            margin="dense"
                            onChange={handleChange}
                            variant="outlined"
                            select
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            {applicationData.map((application) => (
                              <MenuItem
                                dense
                                key={application._id}
                                value={application._id}
                              >
                                {application.application_name}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      )}
                    </Grid>
                  </CardContent>
                </Card>
                <Grid container justifyContent="flex-end" spacing={2}>
                  <Grid item>
                    <ActionButton
                      variant="outlined"
                      size="medium"
                      type="submit"
                      mt={8}
                    >
                      {okText}
                    </ActionButton>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </Container>
      </Dialog>
    </>
  )
}

export default BusinessDialog
